import { createSlice } from "@reduxjs/toolkit";
import Axios from "axios";
import fileDownload from "js-file-download";

//const baseURL = "http://localhost:15301";
const baseURL = "https://lkmtraining.nomination.accenture.com/LKMtrainingNomination-apis";

export const THSlice = createSlice({
 name: "traininghost",
 initialState: {
  error: false,

  nominationDataTH: [],
  courseMasterData: [],
  responseMessage: "",
  monthWIseTrainingList: [],
  nominatedCourseListTH: [],
  nominatedUserListTH: [],
  nominatedUserListTHTemp: [],
  nominatedUserListOriginalData: [],
  isUploaded: false,
  scheduledCount: 0,
  waitlistCount: 0,
  approvedCount: 0,
  rejectedCount: 0,
  nominatedCount: 0,
  filter:2,
  initialCheckboxStates: [],
  isLoaded: false,
  isDataSentSuccess: false,
  isDataSentFailure: false,
  count: [],
 },
 reducers: {
  setNominationDataTH: (state, { payload }) => {
   if (payload.status == 4) {
    state.nominatedUserListTH.map((val, i) => {
     payload.id.map((item, i) => {
      if (val.id == item) {
       val.status = payload.status;
       val.scheduledDate = payload.scheduledDate;
      }
     });
    });
   } else if (payload.status == 5) {
    state.nominatedUserListTH.map((val, i) => {
     payload.id.map((item, i) => {
      if (val.id == item) {
       val.status = payload.status;
      }
     });
    });
   }
   state.nominatedUserListTHTemp = state.nominatedUserListTH;

   if (payload.status == 4) {
    let filetedlist = state.nominatedUserListTH.filter(
     (item) => item.status == payload.filter
    );
    filetedlist.map((val, i) => {
     val.sno = i + 1;
    });
    state.nominatedUserListTH = filetedlist;
   } else {
    let filetedlist = state.nominatedUserListTH.filter(
     (item) => item.status == payload.filter
    );
    filetedlist.map((val, i) => {
     val.sno = i + 1;
    });
    state.nominatedUserListTH = filetedlist;
   }
  },
  setCourseMasterData: (state, { payload }) => {
   state.error = false;
   state.courseMasterData = payload;
  },

  setAddedData: (state, { payload }) => {
   let list = {
    courseCode: payload.courseCode,
    courseName: payload.courseName,
    courseHour: payload.courseHour,
    SMEId: payload.SME,
   };
   console.log("lsit ", payload);
   state.courseMasterData = [...state.courseMasterData, list];

   state.courseMasterData.map((val, i) => {
    val.sno = i + 1;
   });
  },
  setEditData: (state, { payload }) => {
   state.courseMasterData.map((val, i) => {
    if (val.uniqueVal == payload.uniqueID) {
     val.SMEId = payload.smeName;
    }
    val.sno = i + 1;
   });
  },
  setResponse: (state, { payload }) => {
   state.responseMessage = payload;
   state.isUploaded = true;
  },

  setLoaded: (state, { payload }) => {
   state.isLoaded = true;
   state.isDataSentSuccess = false;
   state.isDataSentFailure = false;
  },
  setDataSuccess: (state) => {
    state.isLoaded = false;
    state.isDataSentSuccess = true;
    state.isDataSentFailure = false;
  },
  setDataFailure: (state, payload) => {
    state.isLoaded = false;
    state.isDataSentSuccess = false;
    state.isDataSentFailure = true;
  },
  setMonthWiseTrainingList: (state, { payload }) => {
   state.monthWIseTrainingList = payload;
  },
  setNominatedCourseListTH: (state, { payload }) => {
   state.nominatedCourseListTH = payload;
  },
  setNominatedUserListTH: (state, { payload }) => {
   //  state.nominatedUserListTH = payload;
   //  state.nominatedUserListTHTemp = payload;
   state.nominatedUserListTHTemp = payload;
   state.nominatedUserListOriginalData = payload;
   let filetedlist = payload.filter((item) => item.status == 2);
   filetedlist.map((val, i) => {
    val.sno = i + 1;
   });
   state.nominatedUserListTH = filetedlist;
   state.initialCheckboxStates = filetedlist.map((item) => ({
    [item.id]: false,
   }));
  },

  setNominatedCount: (state, { payload }) => {
   state.nominatedCount = payload[0].nominationCount;
  },
  setCount: (state, { payload }) => {
   state.scheduledCount = 0;
   state.waitlistCount = 0;
   state.rejectedCount = 0;
   state.approvedCount = 0;

   payload.result.map((val, i) => {
    if (val.status == "5") {
     state.waitlistCount = val.count;
    } else if (val.status == "3") {
     state.rejectedCount = val.count;
    } else if (val.status == "2") {
     state.approvedCount = val.count;
    }
   });

   payload.result1.map((val, i) => {
    if (val.prevStatus == "2") {
     state.approvedCount += val.prev_count;
    }
   });
   payload.result2.map((val, i) => {
    if (val.status == "4") {
     state.scheduledCount = val.count;
    }
   });
  },
  setUpdateCount: (state, { payload }) => {
   console.log("payload count", payload.count);
   if (payload.status == 4) {
    state.scheduledCount += payload.count;
   } else if (payload.status == 5) {
    if (payload.filter == 2) {
     state.waitlistCount += payload.count;
    } else if (payload.filter == 4) {
     state.waitlistCount += payload.count;
     state.scheduledCount -= payload.count;
    }
   } else if (payload.status == 2) {
    state.approvedCount += 1;
   } else if (payload.status == 3) {
    state.rejectedCount += 1;
   }
  },
  setFilteredListTH: (state, { payload }) => {
   //  let filetedlist = state.nominatedUserListTHTemp.filter(
   //   (item) => item.status == payload.filter
   //  );
   //  filetedlist.map((val, i) => {
   //   val.sno = i + 1;
   //  });
   payload.map((val, i) => {
    val.sno = i + 1;
   });
   state.nominatedUserListTH = payload;
   state.initialCheckboxStates = payload.map((item) => ({
    [item.id]: false,
   }));
  },
  setAlert: (state) => {
   state.isUploaded = false;
  },

  setError: (state) => {
   state.error = true;
  },
 },
});

// Action creators are generated for each case reducer function
export const {
 setError,
 setNominationDataTH,
 setCourseMasterData,
 setAddedData,
 setEditData,
 setResponse,
 setMonthWiseTrainingList,
 setNominatedCourseListTH,
 setNominatedUserListTH,
 setFilteredListTH,
 setAlert,
 setLoaded,
 setDataSuccess,
 setDataFailure,
 setUpdateCount,

 setNominatedCount,
 setCount,
} = THSlice.actions;

export default THSlice.reducer;

// export function getNominationListDataTH() {
//  return (dispatch) => {
//   Axios.get(`${baseURL}/fetchNominationListTH`)
//    .then((res) => {
//     res.data.map((val, i) => {
//      val.id = i + 1;
//     });
//     dispatch(setNominationDataTH(res.data));
//    })
//    .catch((err) => {
//     dispatch(setError(err));

//     console.error("error is", err);
//    });
//  };
// }

// export function getFilteredNominationListDataTH(filterValue) {
//  return (dispatch) => {
//   Axios.get(`${baseURL}/fetchfilterNominationListTH/${filterValue}`)
//    .then((res) => {
//     res.data.map((val, i) => {
//      val.id = i + 1;
//     });
//     dispatch(setNominationDataTH(res.data));
//    })
//    .catch((err) => {
//     dispatch(setError(err));

//     console.error("error is", err);
//    });
//  };
// }

export function updateTHStatus(id, status, prevStatus, scheduledDate, filter) {
 return (dispatch) => {
  Axios.post(
   `${baseURL}/updateTHStatus`,
   { id, status, prevStatus, scheduledDate },
   {
    headers: {
     Authorization: localStorage.getItem("token"),
     "Content-Type": "application/json",
    },
   }
  )
   .then((res) => {
    // res.data.map((val, i) => {
    //  val.id = i + 1;
    // });
    dispatch(setNominationDataTH({ id, status, scheduledDate, filter }));
   })
   .catch((err) => {
    dispatch(setError(err));
   });
 };
}
export function getCourseMasterData() {
 return (dispatch) => {
  Axios.get(`${baseURL}/fetchmasterdata`, {
   headers: {
    Authorization: localStorage.getItem("token"),
    "Content-Type": "application/json",
   },
  })
   .then((res) => {
    res.data.map((val, i) => {
     val.sno = i + 1;
    });
    dispatch(setCourseMasterData(res.data));
   })
   .catch((err) => {
    dispatch(setError(err));

    console.error("error is", err);
   });
 };
}
export function saveNewCourse(courseCode, courseName, courseHour, SME) {
 return (dispatch) => {
  Axios.post(
   `${baseURL}/savecourse`,
   { courseCode, courseName, courseHour, SME },
   {
    headers: {
     Authorization: localStorage.getItem("token"),
     "Content-Type": "application/json",
    },
   }
  )
   .then((res) => {
    dispatch(setAddedData({ courseCode, courseName, courseHour, SME }));
   })
   .catch((err) => {
    dispatch(setError(err));

    console.error("error is", err);
   });
 };
}

export function saveEditSME(uniqueID, smeName) {
 return (dispatch) => {
  Axios.post(
   `${baseURL}/saveedit`,
   { uniqueID, smeName },
   {
    headers: {
     Authorization: localStorage.getItem("token"),
     "Content-Type": "application/json",
    },
   }
  )
   .then((res) => {
    dispatch(setEditData({ uniqueID, smeName }));
   })
   .catch((err) => {
    dispatch(setError(err));

    console.error("error is", err);
   });
 };
}
export function uploadTHFile(file, month, year, username) {
 return (dispatch) => {
  dispatch(setLoaded())
  Axios.post(`${baseURL}/uploadTrainingList/${month}/${year}/${username}`, file, {
   headers: {
    Authorization: localStorage.getItem("token"),
   },
  })
   .then((res) => {
    dispatch(setResponse("file Uploaded Successfully"));
    dispatch(setDataSuccess())
   })
   .catch((err) => {
    dispatch(setResponse("Sorry!!! Failed to upload"));
    dispatch(setDataFailure())
    dispatch(setError(err));
    console.error("error is", err);
   });
 };
}
export function NominationListDelete(uniqueSessionID, selectedMonthName) {
  return (dispatch) => {
    dispatch(setLoaded())
    Axios.post(
     `${baseURL}/deletenomination`,
     { uniqueSessionID },
     {
      headers: {
       Authorization: localStorage.getItem("token"),
       "Content-Type": "application/json",
      },
    }).then(() => {
      dispatch(getTrainingListMonthWise(selectedMonthName))
      dispatch(setDataSuccess())
    }).catch((err) => {
      console.log('err', err)
    })
}}
export function uploadMasterData(file) {
 return (dispatch) => {
  dispatch(setLoaded())
  Axios.post(`${baseURL}/uploadMasterData`, file, {
   headers: {
    Authorization: localStorage.getItem("token"),
   },
  })
   .then((res) => {
    dispatch(setResponse())
    dispatch(setDataSuccess())
   })
   .catch((err) => {
    console.error("error is", err);
    dispatch(setDataFailure())
   });
 };
}
export function getTrainingListMonthWise(month) {
 console.log("to check");
 return (dispatch) => {
  dispatch(setLoaded())
  Axios.get(`${baseURL}/fetchmonthlist/${month}`, {
   headers: {
    Authorization: localStorage.getItem("token"),
    "Content-Type": "application/json",
   },
  })

   .then((res) => {
    res.data.map((val, i) => {
     val.sno = i + 1;
    });
    dispatch(setMonthWiseTrainingList(res.data));
    // dispatch(setDataSuccess())
   })
   .catch((err) => {
    dispatch(setError(err));

    console.error("error is", err);
   });
 };
}

export function getNominatedCourseListTH() {
 return (dispatch) => {
  Axios.get(`${baseURL}/getnominatedcourselistTH`, {
   headers: {
    Authorization: localStorage.getItem("token"),
    "Content-Type": "application/json",
   },
  })

   .then((res) => {
    res.data.map((val, i) => {
     val.sno = i + 1;
    });
    dispatch(setNominatedCourseListTH(res.data));
   })
   .catch((err) => {
    dispatch(setError(err));

    console.error("error is", err);
   });
 };
}
export function getNominatedUserListTH(code, date) {
 return (dispatch) => {
  Axios.post(
   `${baseURL}/getnominateduserlist/${code}`,
   { date },
   {
    headers: {
     Authorization: localStorage.getItem("token"),
     "Content-Type": "application/json",
    },
   }
  )

   .then((res) => {
    res.data.map((val, i) => {
     val.sno = i + 1;
    });
    dispatch(setNominatedUserListTH(res.data));
   })
   .catch((err) => {
    dispatch(setError(err));

    console.error("error is", err);
   });
 };
}
export function downloadRangeNominatedUserListTH(data) {
  return (dispatch) => {
   Axios.post(
    `${baseURL}/downloadrangenominateduserlist`,
    { data },
      {
        responseType: "blob",
        headers: {
         Authorization: localStorage.getItem("token"),
         "Content-Type": "application/json",
        },
       }
   )
    .then((res) => {
      fileDownload(res.data, `Nomination List.xlsx`);
    })
    .catch((err) => {
     dispatch(setError(err));
     console.error("error is", err);
    });
  };
 }

export function getAllNominationDataTH(course, date, filter) {
 return (dispatch) => {
  Axios.post(
   `${baseURL}/getfiltereddataTH`,
   { course, date, filter },
   {
    headers: {
     Authorization: localStorage.getItem("token"),
     "Content-Type": "application/json",
    },
   }
  )
   .then((res) => {
    dispatch(setFilteredListTH(res.data));
   })
   .catch((err) => {
    dispatch(setError(err));

    console.error("error is", err);
   });
 };
}
export function changeRejectStatusDataTH(id, date, status, code, filter) {
  console.log('id, date, status, filter', id, date, status, filter)
  return (dispatch) => {
    Axios.post(
     `${baseURL}/changerejectedstatus`,
     { id, date, status },
     {
      headers: {
       Authorization: localStorage.getItem("token"),
       "Content-Type": "application/json",
      },
     }
    )
     .then((res) => {
      dispatch(setDataSuccess())
      // dispatch(getNominatedUserListTH(code, date));
      // dispatch(getNominatedCourseListTH())
      dispatch(getCount(code, date))
      dispatch(getNominatedCount(code, date))
      dispatch(getAllNominationDataTH(code, date, filter))
      console.log('filter', filter)
     })
     .catch((err) => {
      dispatch(setError(err));
  
      console.error("error is", err);
     });
   };

}
export function downloadSessionWiseNominatedList(code, date, filter) {
 return (dispatch) => {
  Axios.post(
   `${baseURL}/downloadNominationList`,
   { code, date, filter },
   {
    responseType: "blob",
    headers: {
     Authorization: localStorage.getItem("token"),
     "Content-Type": "application/json",
    },
   }
  )
   .then((res) => {
    fileDownload(res.data, `Nomination List.xlsx`);
   })
   .catch((err) => {
    console.error("error is", err);
   });
 };
}
export function closeAlert() {
 return (dispatch) => {
  dispatch(setAlert());
 };
}

export function uploadAbacusFile(file, username) {
  return (dispatch) => {
   dispatch(setLoaded())
  Axios.post(`${baseURL}/uploadAbacusData/${username}`, file, {
   headers: {
    Authorization: localStorage.getItem("token"),
   },
  })
   .then((res) => {
    dispatch(setResponse("file Uploaded Successfully"));
    dispatch(setDataSuccess())
    console.log('data check', res)
   })
   .catch((err) => {
    dispatch(setResponse("Sorry!!! Failed to upload"));
    dispatch(setDataFailure())
    dispatch(setError(err));

    console.error("error is", err);
   });
 };
}

export function getCount(course, date) {
 return (dispatch) => {
  Axios.post(
   `${baseURL}/getcount`,
   { course, date },
   {
    headers: {
     Authorization: localStorage.getItem("token"),
     "Content-Type": "application/json",
    },
   }
  )
   .then((res) => {
    dispatch(setCount(res.data));
   })
   .catch((err) => {
    dispatch(setError(err));

    console.error("error is", err);
   });
 };
}

export function getNominatedCount(course, date) {
 return (dispatch) => {
  Axios.post(
   `${baseURL}/getnominatedcount`,
   { course, date },
   {
    headers: {
     Authorization: localStorage.getItem("token"),
     "Content-Type": "application/json",
    },
   }
  )
   .then((res) => {
    dispatch(setNominatedCount(res.data));
   })
   .catch((err) => {
    dispatch(setError(err));

    console.error("error is", err);
   });
 };
}

export function updateCount(count, status, prevStatus, filter) {
 return (dispatch) => {
  dispatch(setUpdateCount({ count, status, prevStatus, filter }));
 };
}

export function finaliseBatch(course, date) {
 return (dispatch) => {
  Axios.post(
   `${baseURL}/finalisebatch`,
   { course, date },
   {
    headers: {
     Authorization: localStorage.getItem("token"),
     "Content-Type": "application/json",
    },
   }
  )
   .then((res) => {
    //  dispatch(setNominatedCount(res.data));
   })
   .catch((err) => {
    dispatch(setError(err));

    console.error("error is", err);
   });
 };
}